module.exports = __webpack_public_path__ + "assets/img/directions_bus.95aa7a49.svg";